import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultKagiOptions, KagiSeriesOptions } from './options'
import { KagiSeriesRenderer } from './renderer'
import { KagiData } from './data'

export class CustomKagiSeries<TData extends KagiData>
    implements ICustomSeriesPaneView<Time, TData, KagiSeriesOptions> {
    _renderer: KagiSeriesRenderer<TData>

    constructor() {
        this._renderer = new KagiSeriesRenderer()
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        const a =  [plotRow.nextCandle?.high || plotRow.high, plotRow.nextCandle?.low || plotRow.low , plotRow?.ltp || plotRow.close];
        return a;
    }

    isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<TData>).close === undefined && (data as Partial<TData>).open === undefined
    }

    renderer(): KagiSeriesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: KagiSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultKagiOptions
    }
}
